<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" style="height: 90%;" v-if="addType=='detail'">
        <div class="write-txt">
          <p class="write-title">打卡类型：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont">{{addObj.type==1?'演讲打卡':''}}</div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">标题：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont">{{addObj.title}}</div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">打卡内容：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.content"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">打卡规则：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.rule?addObj.rule:'无'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">打卡图片：<span>*</span></p>
          <div class="write-text">
            <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">审核状态：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.verifystatus==0?'未审核':addObj.verifystatus==1?'已审核':'审核未通过'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">状态：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.status==0?'未开始':addObj.status==1?'进行中':addObj.status==2?'已结束':'已关闭'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">总人数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.totalnum"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">天数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.num"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">打卡含vip天数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.contain_vip_num"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">打卡成功送vip天数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.deliver_vip_num"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">开始时间：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.begindate?addObj.begindate:'无'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">结束时间：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.enddate?addObj.enddate:'无'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">人数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.totalnum"></div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">总人数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.totalnum"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">重复：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.repeat==1?'每天重复':addObj.repeat==2?'每个工作日重复':'自定义'"></div>
          </div>
        </div>
        <div class="write-txt"  v-if="addObj.repeat==9">
          <p class="write-title">自定义重复：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.repeatinfo?addObj.repeatinfo:'无'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">积分现金：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.contracttype==1?'积分':'现金'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">契约金：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.moneycontract"></div>
          </div>
        </div>
        
        <div class="write-txt">
          <p class="write-title">失败豁免次数：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.exempt"></div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">打卡凭证：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.voucher"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">额外要求：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.extracont"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">是否打卡失败再次添加：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.islosejoin==0?'不在参加':'可再次参加'"></div>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">添加时间：<span>*</span></p>
          <div class="write-text">
            <div class="write-cont" v-html="addObj.add_time"></div>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="MobelBox" style="height: 90%;" v-else-if="addType=='review'">
        <div class="write-txt">
          <p class="write-title">审核结果：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.verifystatus" placeholder="请选择">
              <el-option key="0" label="未审核" value="0" disabled></el-option>
              <el-option
                v-for="item in reviewList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="reviewSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="MobelBox" style="height: 90%;" v-else-if="addType=='ai'">
        <div class="write-txt">
          <p class="write-title">AI评论提示词：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="aiObj.ai_comment_cue_word"></textarea>
          </div>
        </div>
        <div class="write-txt" v-for="(item,index) in aiObj.dialogue_dim" :key="index">
          <p class="write-title">维度{{(index+1)}}：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="aiObj.dialogue_dim[index]"></textarea>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="aiSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <!-- <div class="searchBox clear">
            <div class="search-item">
              <p>名称：</p>
              <input type="text" placeholder="请输入要搜索的名称" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>排序：</p>
              <el-select v-model="obj.sort" placeholder="请选择">
                <el-option
                  v-for="item in sortList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>打卡状态：</p>
              <el-select v-model="obj.publish_status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>支付方式：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option
                  v-for="item in createList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
             <div class="search-item">
              <p>审核状态：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option key="1" label="未审核" value="1"></el-option>
                <el-option key="2" label="审核通过" value="2"></el-option>
                <el-option key="3" label="审核不通过" value="3"></el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div> -->
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.cid">{{item.cid}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p>
                <img :src="'https://pic.speechcoach.cn/'+item.image" alt="">
              </p>
              <p :title="item.status==0?'未开始':item.status==1?'进行中':item.status==2?'已结束':'已关闭'">{{item.status==0?'未开始':item.status==1?'进行中':item.status==2?'已结束':'已关闭'}}</p>
              <p :title="item.username">{{item.username}}</p>
              <p :title="item.num">{{item.num}}</p>
              <p :title="item.totalnum">{{item.totalnum}}</p>
              <p :title="item.contracttyp==1?'积分':'现金'">{{item.contracttyp==1?'积分':'现金'}}</p>
              <p :title="item.verifystatus==1?'已审核':item.verifystatus==0?'未审核':'未通过'">{{item.verifystatus==1?'已审核':item.verifystatus==0?'未审核':'未通过'}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="详情" class="btn btn-revise" @click="lookDetail(item,'detail')">详情</button>
                <button title="审核" class="btn btn-remove" @click="lookDetail(item,'review')">审核</button>
                <button title="AI评论提示词" class="btn btn-remove" @click="lookDetail(item,'ai')">AI评论提示词</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClockInList,clockInVerify,delLexicon,addClockInAiCueWord,getClockInDetail  } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'10',
      titleList:[
        {id:1,title:'打卡ID'},
        {id:2,title:'标题'},
        {id:3,title:'图片'},
        {id:4,title:'状态'},
        {id:6,title:'发起者'},
        {id:7,title:'打卡天数'},
        {id:8,title:'打卡总人数'},
        {id:9,title:'支付方式'},
        {id:10,title:'审核状态'},
        {id:11,title:'添加时间'},
        {id:13,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{},
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'中文'},
        {id:2,title:'英文'},
      ],
      reviewList:[
        {id:1,title:'通过'},
        {id:2,title:'不通过'},
      ],
      aiObj:{
        cid:'',
        ai_comment_cue_word:'',
        dialogue_dim:['','','','','']
      },
      cid:'',
      statusList:[
        {id:1,title:'未开始'},
        {id:2,title:'进行中'},
        {id:3,title:'已结束'},
        {id:4,title:'已关闭'},
      ],
      createList:[
        {id:1,title:'积分'},
        {id:2,title:'现金'},
      ]
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getClockInList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLexicon({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        that.removeID = '';
      }
      this.addType = '';
      that.reviewIndex = 1;
      that.removeID = '';
      that.aiObj={
        cid:'',
        ai_comment_cue_word:'',
        dialogue_dim:['','','','','']
      }
    },

    closeSub(){
      this.addType = '';
      this.removeType = false;
      this.removeID = '';
      this.aiObj={
        cid:'',
        ai_comment_cue_word:'',
        dialogue_dim:['','','','','']
      }
    },

    async lookDetail(e,type){
      var that = this;
      this.cid = e.cid;
      try {
        const response = await getClockInDetail({cid:e.cid},this.token);
        if(response.code == 200){
          that.addType = type;
          response.data.verifystatus = response.data.verifystatus;
          that.addObj = response.data;
          if(type == 'ai'){
            that.aiObj.ai_comment_cue_word = response.data.ai_comment_cue_word;
            that.aiObj.dialogue_dim = response.data.dialogue_dim;
            if(response.data.dialogue_dim == '' || response.data.dialogue_dim == null){
              that.aiObj.dialogue_dim = ['','','','',''];
            }
          } 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async reviewSub(){
      var that = this;
      var obj = {
        cid:that.cid,
        verifystatus:that.addObj.verifystatus
      }
      try {
        const response = await clockInVerify(obj,this.token);
        if(response.code == 200){
          
          that.$message('审核成功');
          that.getList();
          that.ModelHide('remove');    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async aiSub(){
      var that = this;
      this.aiObj.cid = this.cid;
      try {
        const response = await addClockInAiCueWord(this.aiObj,this.token);
        if(response.code == 200){
          that.$message('添加成功');
          that.getList();
          that.ModelHide('remove');    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 11 );
  }

  .dataList .listItem p img{
    display: block;
    width: 100%;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .MobelBox .write-cont{
    background-color: #F5F5F5;
    border-radius: 16px;
    width: 80%;
    display: block;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/clock/index.vue